__turbopack_context__.v({
  "block": "method-static-module__EYZaBW__block",
  "card": "method-static-module__EYZaBW__card",
  "connector": "method-static-module__EYZaBW__connector",
  "connectorArrow": "method-static-module__EYZaBW__connectorArrow",
  "connectorLine": "method-static-module__EYZaBW__connectorLine",
  "dot": "method-static-module__EYZaBW__dot",
  "eyebrow": "method-static-module__EYZaBW__eyebrow",
  "item": "method-static-module__EYZaBW__item",
  "itemLabel": "method-static-module__EYZaBW__itemLabel",
  "itemText": "method-static-module__EYZaBW__itemText",
  "items": "method-static-module__EYZaBW__items",
  "num": "method-static-module__EYZaBW__num",
  "scoring": "method-static-module__EYZaBW__scoring",
  "title": "method-static-module__EYZaBW__title",
  "wrap": "method-static-module__EYZaBW__wrap",
});
